module.exports = __webpack_public_path__ + "static/media/whiteBox.5b288bcd.svg";